module.exports = __webpack_public_path__ + "static/sled-work.7246434c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/jerron/sled-work.jpg
// module id = 609
// module chunks = 35783957827783